module.exports = __webpack_public_path__ + "static/media/upper_swoosh.79414778.png";